import React, { useRef, useEffect, useState } from "react";
declare const window: any;

function AmenitiesOverlaysContainer({
  colors,
  theme,
  active,
  frame,
  amenidad,
  amenidadesAttributes,
  amenitiesUrl,
  originalWidth,
  originalHeight,
  amenidades,
  setSpinSelected,
  setGaleriaSelected,
  setOriginalGleriaSelected,
  setSubMenuSelected,
  setIsAnimationAmenites,
  isAnimationAmenities,
  amenities_hierarchical
}: any) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  const [amenitiesData, setAmenitiesData]: any = React.useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [currentRadius, setCurrentRadius]: any = useState(5);
  const [currentRadiusPunto, setCurrentRadiusPunto]: any = useState(2);
  const [decreasing, setDecreasing] = useState(false);

  useEffect(() => {
    // Esta función se ejecutará cada 65 milisegundos
    const interval = setInterval(() => {
      // Actualizar el estado basado en el estado anterior
      setCurrentRadiusPunto((prevRadius) => {
        if (prevRadius + 1 <= 5 && !decreasing) {
          return prevRadius + 1;
        } else if (prevRadius - 1 >= 2 && decreasing) {
          return prevRadius - 1;
        }
        // Cambiar la dirección de la animación
        setDecreasing((prevDecreasing) => !prevDecreasing);
        return prevRadius; // No cambia el radio si no se cumple ninguna condición
      });
    }, 100);

    // Devolver una función de limpieza para detener el intervalo
    return () => clearInterval(interval);
  }, [decreasing]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${window.hybrid ? "./" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"}${amenitiesUrl}`
        );
        const data = await response.json();
        setAmenitiesData(data.amenities_coord_file);
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      }
    };

    fetchData();

    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [amenitiesUrl]);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;

    // Limpia el contenido del SVG de inmediato
    svg.innerHTML = "";

    // Función para crear el nuevo SVG
    const createSVG = () => {
      // Ordena las amenidades por su coordenada Y para manejar la distribución desde la parte superior
      const amenitiesSortedByY = amenitiesData[
        amenitiesData.findIndex((indexFrame) => indexFrame.frame === frame)
      ]?.amenities?.sort((a, b) => a.verts[1] - b.verts[1]);

      const sortedAmenities = amenitiesData[40]?.amenities?.sort(
        (a, b) => a.verts[0] - b.verts[0]
      );

      let tempObject = {};

      sortedAmenities?.map((data, index) => {
        tempObject[data.id] = index + 1;
        return null;
      });

      var counter = sortedAmenities?.length;

      Object.keys(tempObject).map((key) => {
        if (tempObject[key] === "") {
          tempObject[key] = counter;
          counter++;
        }
        return null;
      });

      // Este es el espacio vertical deseado entre cada círculo
      const verticalSpacing = 50;

      // Espacio horizontal en el que no pueden haber dos íconos a la misma altura
      const horizontalThreshold = 100;

      let lastYFinal = [];

      // Almacena la última posición Y de los íconos para evitar solapamientos
      const lastYPositions = new Map();

      amenitiesSortedByY?.forEach((amenity, ind) => {
        if (amenidad === "" || amenidad === amenity.id) {
          if (amenidadesAttributes.length === 0 || amenidadesAttributes.find((e) => e.id === amenity.id)) {
            let x = amenity.verts[0];
            let y = amenity.verts[1];

            const radio = currentRadius + 10; // El radio del círculo

            // Dibujar la línea desde el círculo hasta la ubicación en el edificio
            const line = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "line"
            );
            line.setAttribute("x1", x.toString());
            line.setAttribute(
              "y1",
              (
                y -
                (tempObject[amenity.id] % 3 === 0
                  ? 170
                  : tempObject[amenity.id] % 2 === 0
                    ? 115
                    : 40)
              ).toString()
            );
            line.setAttribute("x2", x.toString()); // Ajustar si es necesario
            line.setAttribute("y2", amenity.verts[1].toString()); // Ajustar si es necesario
            line.setAttribute("fill", theme === "Dark" ? "#212427" : "#FFFFFF");
            line.setAttribute("stroke", theme === "Dark" ? "#212427" : "#FFFFFF");
            line.setAttribute("stroke-width", "2");
            svg.appendChild(line);

            // Crear y añadir el círculo al SVG
            const circle = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "circle"
            );
            circle.setAttribute("cx", x.toString());
            circle.setAttribute(
              "cy",
              (
                y -
                (tempObject[amenity.id] % 3 === 0
                  ? 170
                  : tempObject[amenity.id] % 2 === 0
                    ? 115
                    : 40)
              ).toString()
            );
            console.log(theme);

            circle.setAttribute("r", (radio * 2).toString());
            circle.setAttribute("stroke", theme === "Dark" ? "#212427" : theme === "Light" ? "#FFF" : "#FFF");
            circle.setAttribute("stroke-width", "2");
            circle.setAttribute("class", `point-am ${theme}`);
            //circle.setAttribute("class", `point-am`);
            svg.appendChild(circle);

            // Crear y añadir la imagen dentro del círculo
            const image = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "image"
            );
            const iconUrl = amenities_hierarchical === 1 && amenidadesAttributes.length > 0
              ? amenidadesAttributes.find((value) => value.id === amenity.id)?.icon
              : amenities_hierarchical === 1
                ? amenidades
                  .map((amenidad) => amenidad.amenities.find((value) => value.id === amenity.id)?.icon)
                  .find((icon) => icon !== undefined)
                : amenidades.find((value) => value.id === amenity.id)?.icon;

            image.setAttribute(
              "href",
              (window.hybrid ? "./" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + (iconUrl || "")
            );
            image.setAttribute("x", (x - radio).toString());
            image.setAttribute(
              "y",
              (
                y -
                (tempObject[amenity.id] % 3 === 0
                  ? 170
                  : tempObject[amenity.id] % 2 === 0
                    ? 115
                    : 40) -
                radio
              ).toString()
            );
            image.setAttribute("height", (2 * radio).toString());
            image.setAttribute("width", (2 * radio).toString());
            image.setAttribute("fill", "#FFFFFF");
            image.setAttribute("stroke", "#FFFFFF");

            /* image.setAttribute(
              "class",
              theme === "Light" ? "Light-svg" : "Dark-svg"
            ); */
            svg.appendChild(image);

            // Crear y añadir el círculo al SVG
            const point = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "circle"
            );
            point.setAttribute("cx", x.toString());
            point.setAttribute("cy", amenity.verts[1].toString());
            point.setAttribute("r", currentRadiusPunto.toString());
            point.setAttribute("fill", theme === "Dark" ? "#212427" : "#FFFFFF");
            point.setAttribute("stroke", theme === "Dark" ? "#212427" : "#FFFFFF");
            point.setAttribute("stroke-width", "2");
            svg.appendChild(point);

            if (amenidad === amenity.id && isAnimationAmenities) {
              setTimeout(() => {
                let activeAmenities;

                if (amenities_hierarchical === 1 && amenidadesAttributes.length > 0) {
                  activeAmenities = amenidadesAttributes.find((value) => value.id === amenity.id);
                } else if (amenities_hierarchical === 1 && amenidadesAttributes.length === 0) {
                  activeAmenities = amenidades
                    .map((amenidad) => amenidad.amenities.find((a) => a.id === amenity.id))
                    .find((amenity) => amenity !== undefined); // Filtrar los valores undefined
                } else {
                  activeAmenities = amenidades.find((value) => value.id === amenity.id);
                }
                console.log(activeAmenities);
                
                if (
                  activeAmenities.menu.length > 0 &&
                  activeAmenities?.spin === null
                ) {
                  setGaleriaSelected(activeAmenities?.menu);
                  setSubMenuSelected("Galería");
                  setOriginalGleriaSelected(activeAmenities?.menu);
                  setSpinSelected([]);
                }
              }, 1200);
            }

            setIsAnimationAmenites(false);
          }
        }
      });
    };

    // Limpia el timeout anterior para evitar duplicaciones
    const timeoutId: any = isAnimationAmenities
      ? setTimeout(createSVG, 600)
      : createSVG();
    return () => {
      if (isAnimationAmenities) {
        clearTimeout(timeoutId); // Limpia el timeout si las dependencias cambian
      }
      //clearTimeout(timeoutGalery); // Limpia el timeout si las dependencias cambian
      svg.innerHTML = ""; // Limpia el SVG de inmediato cuando el efecto se limpia
    };
  }, [amenitiesData, screenHeight, screenWidth, frame, amenidad, theme, amenidadesAttributes]);

  return (
    <svg
      ref={svgRef}
      width={screenWidth}
      height={screenHeight}
      preserveAspectRatio="xMidYMid slice"
      viewBox={`0 0 ${originalWidth} ${originalHeight}`}
      style={{
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        cursor: "pointer",
        top: 0,
      }}
    ></svg>
  );
}

export default AmenitiesOverlaysContainer;
